module.exports = __webpack_public_path__ + "exo-latin-700.7348a6cf42fcb58f0985.eot";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-700.eot
// module id = ../../../../typeface-exo/files/exo-latin-700.eot
// module chunks = styles